(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasso-collections-directory"] && !Shopify.designMode) return;
  try {
    (function(){function init(root){if(!root||root.dataset.vclReady==='1')return;root.dataset.vclReady='1';var mode='collection',aud='all',mb=[...root.querySelectorAll('[data-vcl-mode]')],ab=[...root.querySelectorAll('[data-vcl-audience]')],panels=[...root.querySelectorAll('[data-vcl-panel]')],secs=[...root.querySelectorAll('[data-vcl-section]')],ng=[...root.querySelectorAll('[data-vcl-need-group]')],promos=[...root.querySelectorAll('[data-vcl-promo]')],quizHelp=root.querySelector('[data-vcl-quiz-help]'),meta=root.querySelector('[data-vcl-meta]');function offset(){var bar=document.querySelector('.announcement-bar[data-sticky="true"]'),top=0;if(bar){var mobile=matchMedia('(max-width:768px)').matches,sm=bar.dataset.stickyMobile==='true';if(!mobile||sm)top=bar.getBoundingClientRect().height}root.style.setProperty('--vcl-sticky-top',top+'px')}function render(){mb.forEach(b=>{var a=b.dataset.vclMode===mode;b.classList.toggle('is-active',a);b.setAttribute('aria-pressed',a)});ab.forEach(b=>{var a=b.dataset.vclAudience===aud;b.classList.toggle('is-active',a);b.setAttribute('aria-pressed',a)});panels.forEach(p=>p.hidden=p.dataset.vclPanel!==mode);secs.forEach(s=>s.classList.toggle('is-filtered-out',aud!=='all'&&s.dataset.vclSection!==aud));ng.forEach(g=>g.classList.toggle('is-filtered-out',aud!=='all'&&g.dataset.vclNeedGroup!==aud));var promoKey=mode+':'+aud;promos.forEach(p=>p.hidden=p.dataset.vclPromo!==promoKey);if(quizHelp)quizHelp.hidden=!(mode==='collection'&&aud==='all');if(meta){meta.textContent=mode==='collection'?(aud==='all'?root.dataset.countAll:root.dataset.countOne):(aud==='all'?root.dataset.needsAll:aud==='women'?root.dataset.needsWomen:root.dataset.needsMen)}}mb.forEach(b=>b.addEventListener('click',()=>{mode=b.dataset.vclMode;render()}));ab.forEach(b=>b.addEventListener('click',()=>{aud=b.dataset.vclAudience;render()}));var sw=root.querySelector('[data-vcl-switch-need]');if(sw)sw.addEventListener('click',()=>{mode='need';render();root.querySelector('.vcl__tools-wrap').scrollIntoView({behavior:'smooth',block:'start'})});addEventListener('resize',offset,{passive:true});offset();render()}function all(){document.querySelectorAll('[data-vcl-root]').forEach(init)}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',all):all();document.addEventListener('shopify:section:load',all)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasso-pdp-men"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var mainImage=root.querySelector('[data-vasso-men-main-image]');

    root.querySelectorAll('[data-vasso-men-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-vasso-men-thumb]').forEach(function(x){x.classList.remove('is-active');});
        btn.classList.add('is-active');
        if(mainImage&&btn.dataset.src){mainImage.src=btn.dataset.src;}
      });
    });

    var mainSelect=root.querySelector('[data-vasso-men-variant]');
    var stickySelect=root.querySelector('[data-vasso-men-sticky-variant]');
    var price=root.querySelector('[data-vasso-men-price]');
    var addPrice=root.querySelector('[data-vasso-men-add-price]');
    var stickyPrice=root.querySelector('[data-vasso-men-sticky-price]');
    var stickyMeta=root.querySelector('[data-vasso-men-sticky-meta]');
    var addButton=root.querySelector('[data-vasso-men-add]');
    var stickyAdd=root.querySelector('[data-vasso-men-sticky-add]');
    var variantCards=root.querySelectorAll('[data-vasso-men-variant-card]');

    function syncVariantCards(value){
      variantCards.forEach(function(card){
        var selected=String(card.dataset.variantId)===String(value);
        card.classList.toggle('is-selected',selected);
        card.setAttribute('aria-pressed',selected?'true':'false');
      });
    }

    variantCards.forEach(function(card){
      card.addEventListener('click',function(){
        if(!mainSelect||card.disabled||card.dataset.available==='false')return;
        mainSelect.value=card.dataset.variantId;
        mainSelect.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });


    function applyVariant(select,source){
      if(!select)return;
      var option=select.options[select.selectedIndex];
      if(!option)return;
      var formatted=option.dataset.price||'';
      var available=option.dataset.available!=='false';

      if(price)price.textContent=formatted;
      if(addPrice)addPrice.textContent=formatted;
      if(stickyPrice)stickyPrice.textContent=formatted;
      if(stickyMeta&&option.textContent)stickyMeta.textContent=option.textContent.trim().split('—')[0].trim();
      if(addButton)addButton.disabled=!available;
      if(stickyAdd)stickyAdd.disabled=!available;
      if(source!=='sticky'&&stickySelect)stickySelect.value=select.value;
      if(source!=='main'&&mainSelect)mainSelect.value=select.value;
      syncVariantCards(select.value);
    }

    if(mainSelect)mainSelect.addEventListener('change',function(){applyVariant(mainSelect,'main');});
    if(stickySelect)stickySelect.addEventListener('change',function(){applyVariant(stickySelect,'sticky');});
    if(mainSelect)syncVariantCards(mainSelect.value);

    var qty=root.querySelector('[data-vasso-men-qty]');
    var stickyQty=root.querySelector('[data-vasso-men-sticky-qty]');

    function syncQty(value){
      var n=Math.max(1,parseInt(value||1,10));
      if(qty)qty.value=n;
      if(stickyQty)stickyQty.textContent=n;
    }

    root.querySelectorAll('[data-vasso-men-minus],[data-vasso-men-sticky-minus]').forEach(function(btn){
      btn.addEventListener('click',function(){syncQty((qty?parseInt(qty.value,10):1)-1);});
    });

    root.querySelectorAll('[data-vasso-men-plus],[data-vasso-men-sticky-plus]').forEach(function(btn){
      btn.addEventListener('click',function(){syncQty((qty?parseInt(qty.value,10):1)+1);});
    });

    if(qty)qty.addEventListener('change',function(){syncQty(qty.value);});

    /* VASSO MEN PDP AJAX CART DRAWER */
    (function bindVassoAjaxCart(){
      var form=root.querySelector('.vasso-men-pdp__form');
      if(!form || form.dataset.vassoAjaxCartReady==='1')return;
      form.dataset.vassoAjaxCartReady='1';

      var submitting=false;
      var defaultVariantAvailable=root.getAttribute('data-default-variant-available')!=='false';

      function currentVariantAvailable(){
        if(mainSelect && mainSelect.options && mainSelect.selectedIndex>=0){
          return mainSelect.options[mainSelect.selectedIndex].dataset.available!=='false';
        }
        return defaultVariantAvailable;
      }

      function cartDrawerVisible(){
        var drawer=document.getElementById('CartDrawer');
        if(!drawer)return false;
        if(drawer.getAttribute('aria-hidden')==='false')return true;
        if(drawer.classList.contains('drawer--is-open')||drawer.classList.contains('is-open'))return true;
        var style=window.getComputedStyle(drawer);
        if(style.display==='none'||style.visibility==='hidden'||Number(style.opacity||1)===0)return false;
        var rect=drawer.getBoundingClientRect();
        return rect.width>0&&rect.height>0&&rect.right>2&&rect.left<(window.innerWidth-2);
      }

      function openCartDrawer(addedProduct){
        try{
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:addedProduct}}));
        }catch(error){}

        try{
          document.dispatchEvent(new CustomEvent('cart:build'));
        }catch(error){}

        window.setTimeout(function(){
          if(cartDrawerVisible())return;

          var trigger=document.querySelector('.js-drawer-open-cart[aria-controls="CartDrawer"], .js-drawer-open-cart');
          if(trigger&&typeof trigger.click==='function'){
            trigger.click();
            return;
          }

          if(window.theme&&typeof window.theme.CartDrawer==='function'){
            try{
              window.__vassoPdpCartDrawer=window.__vassoPdpCartDrawer||new window.theme.CartDrawer();
              if(window.__vassoPdpCartDrawer.init&&!window.__vassoPdpCartDrawer.__vassoInitialized){
                window.__vassoPdpCartDrawer.init();
                window.__vassoPdpCartDrawer.__vassoInitialized=true;
              }
              if(window.__vassoPdpCartDrawer.open)window.__vassoPdpCartDrawer.open();
            }catch(error){}
          }
        },140);
      }

      function setSubmitting(state){
        submitting=state;
        var available=currentVariantAvailable();
        if(addButton)addButton.disabled=state||!available;
        if(stickyAdd)stickyAdd.disabled=state||!available;
      }

      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(submitting)return;

        var formData=new FormData(form);
        setSubmitting(true);

        var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        fetch(rootUrl+'cart/add.js',{
          method:'POST',
          headers:{
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:formData,
          credentials:'same-origin'
        })
          .then(function(response){
            return response.json().then(function(data){
              if(!response.ok){
                var message=(data&&data.description)||(data&&data.message)||'Could not add this product to the cart.';
                throw new Error(message);
              }
              return data;
            });
          })
          .then(function(addedProduct){
            openCartDrawer(addedProduct);
          })
          .catch(function(error){
            console.error('VASSO add to cart failed:',error);
            if(window.alert)window.alert(error.message||'Could not add this product to the cart.');
          })
          .finally(function(){
            setSubmitting(false);
          });
      });
    })();


    root.querySelectorAll('.vasso-men-pdp__related-scroll').forEach(function(track){
      if(track.dataset.vassoSliderReady==='true')return;
      track.dataset.vassoSliderReady='true';

      var nav=document.createElement('div');
      nav.className='vasso-men-pdp__related-nav';

      var prev=document.createElement('button');
      var next=document.createElement('button');
      prev.type='button';
      next.type='button';

      var rtl=(root.getAttribute('dir')||'').toLowerCase()==='rtl';
      prev.textContent=rtl?'›':'‹';
      next.textContent=rtl?'‹':'›';
      prev.setAttribute('aria-label','Previous products');
      next.setAttribute('aria-label','Next products');

      nav.appendChild(prev);
      nav.appendChild(next);
      track.parentNode.insertBefore(nav,track);

      function move(forward){
        var amount=Math.max(240,Math.round(track.clientWidth*.72));
        var left;
        if(rtl){
          left=forward?-amount:amount;
        }else{
          left=forward?amount:-amount;
        }
        track.scrollBy({left:left,behavior:'smooth'});
      }

      prev.addEventListener('click',function(){move(false);});
      next.addEventListener('click',function(){move(true);});
    });

    var sticky=root.querySelector('.vasso-men-pdp__sticky');
    var stickyTrigger=addButton || root.querySelector('.vasso-men-pdp__purchase') || root.querySelector('.vasso-men-pdp__hero');

    function getStickyTop(){
      if(!sticky)return 0;
      var candidates=[
        document.querySelector('.site-header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('[data-section-type="header"]'),
        document.querySelector('header')
      ];
      var top=0;
      candidates.forEach(function(el){
        if(!el)return;
        var style=window.getComputedStyle(el);
        if(style.position==='fixed'||style.position==='sticky'){
          var rect=el.getBoundingClientRect();
          if(rect.top<=4&&rect.bottom>top)top=rect.bottom;
        }
      });
      sticky.style.top=Math.max(0,Math.round(top))+'px';
      return top;
    }

    function updateSticky(){
      if(!sticky||!stickyTrigger)return;
      var top=getStickyTop();
      var triggerBottom=stickyTrigger.getBoundingClientRect().bottom;
      sticky.classList.toggle('is-visible',triggerBottom<=top+8);
    }

    updateSticky();
    window.addEventListener('scroll',updateSticky,{passive:true});
    window.addEventListener('resize',updateSticky);

  }

  document.querySelectorAll('[data-vasso-men-pdp]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasso-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var mainImage=root.querySelector('[data-vasso-main-image]');
    root.querySelectorAll('[data-vasso-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-vasso-thumb]').forEach(function(x){x.classList.remove('is-active');});
        btn.classList.add('is-active');
        if(mainImage&&btn.dataset.src){mainImage.src=btn.dataset.src;}
      });
    });

    var mainSelect=root.querySelector('[data-vasso-variant-select]');
    var stickySelect=root.querySelector('[data-vasso-sticky-variant]');
    var price=root.querySelector('[data-vasso-price]');
    var addPrice=root.querySelector('[data-vasso-add-price]');
    var stickyPrice=root.querySelector('[data-vasso-sticky-price]');
    var stickyMeta=root.querySelector('[data-vasso-sticky-meta]');
    var addButton=root.querySelector('[data-vasso-add]');
    var stickyAdd=root.querySelector('[data-vasso-sticky-add]');
    var variantCards=root.querySelectorAll('[data-vasso-variant-card]');

    function syncVariantCards(value){
      variantCards.forEach(function(card){
        var selected=String(card.dataset.variantId)===String(value);
        card.classList.toggle('is-selected',selected);
        card.setAttribute('aria-pressed',selected?'true':'false');
      });
    }

    variantCards.forEach(function(card){
      card.addEventListener('click',function(){
        if(!mainSelect||card.disabled||card.dataset.available==='false')return;
        mainSelect.value=card.dataset.variantId;
        mainSelect.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });


    function applyVariant(select,source){
      if(!select)return;
      var option=select.options[select.selectedIndex];
      if(!option)return;
      var formatted=option.dataset.price||'';
      var available=option.dataset.available!=='false';
      if(price)price.textContent=formatted;
      if(addPrice)addPrice.textContent=formatted;
      if(stickyPrice)stickyPrice.textContent=formatted;
      if(stickyMeta&&option.textContent)stickyMeta.textContent=option.textContent.trim().split('—')[0].trim();
      if(addButton)addButton.disabled=!available;
      if(stickyAdd)stickyAdd.disabled=!available;
      if(source!=='sticky'&&stickySelect){stickySelect.value=select.value;}
      if(source!=='main'&&mainSelect){mainSelect.value=select.value;}
      syncVariantCards(select.value);
    }
    if(mainSelect){mainSelect.addEventListener('change',function(){applyVariant(mainSelect,'main');});}
    if(stickySelect){stickySelect.addEventListener('change',function(){applyVariant(stickySelect,'sticky');});}
    if(mainSelect)syncVariantCards(mainSelect.value);

    var qty=root.querySelector('[data-vasso-qty]');
    var stickyQty=root.querySelector('[data-vasso-sticky-qty]');
    function syncQty(value){
      var n=Math.max(1,parseInt(value||1,10));
      if(qty)qty.value=n;
      if(stickyQty)stickyQty.textContent=n;
    }
    root.querySelectorAll('[data-vasso-qty-minus],[data-vasso-sticky-minus]').forEach(function(btn){
      btn.addEventListener('click',function(){syncQty((qty?qty.value:1)-1);});
    });
    root.querySelectorAll('[data-vasso-qty-plus],[data-vasso-sticky-plus]').forEach(function(btn){
      btn.addEventListener('click',function(){syncQty(parseInt(qty?qty.value:1,10)+1);});
    });
    if(qty){qty.addEventListener('change',function(){syncQty(qty.value);});}

    /* VASSO PDP AJAX CART DRAWER */
    (function bindVassoAjaxCart(){
      var form=root.querySelector('.vasso-pdp__form');
      if(!form || form.dataset.vassoAjaxCartReady==='1')return;
      form.dataset.vassoAjaxCartReady='1';

      var submitting=false;
      var defaultVariantAvailable=root.getAttribute('data-default-variant-available')!=='false';

      function currentVariantAvailable(){
        if(mainSelect && mainSelect.options && mainSelect.selectedIndex>=0){
          return mainSelect.options[mainSelect.selectedIndex].dataset.available!=='false';
        }
        return defaultVariantAvailable;
      }

      function cartDrawerVisible(){
        var drawer=document.getElementById('CartDrawer');
        if(!drawer)return false;
        if(drawer.getAttribute('aria-hidden')==='false')return true;
        if(drawer.classList.contains('drawer--is-open')||drawer.classList.contains('is-open'))return true;
        var style=window.getComputedStyle(drawer);
        if(style.display==='none'||style.visibility==='hidden'||Number(style.opacity||1)===0)return false;
        var rect=drawer.getBoundingClientRect();
        return rect.width>0&&rect.height>0&&rect.right>2&&rect.left<(window.innerWidth-2);
      }

      function openCartDrawer(addedProduct){
        try{
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:addedProduct}}));
        }catch(error){}

        try{
          document.dispatchEvent(new CustomEvent('cart:build'));
        }catch(error){}

        window.setTimeout(function(){
          if(cartDrawerVisible())return;

          var trigger=document.querySelector('.js-drawer-open-cart[aria-controls="CartDrawer"], .js-drawer-open-cart');
          if(trigger&&typeof trigger.click==='function'){
            trigger.click();
            return;
          }

          if(window.theme&&typeof window.theme.CartDrawer==='function'){
            try{
              window.__vassoPdpCartDrawer=window.__vassoPdpCartDrawer||new window.theme.CartDrawer();
              if(window.__vassoPdpCartDrawer.init&&!window.__vassoPdpCartDrawer.__vassoInitialized){
                window.__vassoPdpCartDrawer.init();
                window.__vassoPdpCartDrawer.__vassoInitialized=true;
              }
              if(window.__vassoPdpCartDrawer.open)window.__vassoPdpCartDrawer.open();
            }catch(error){}
          }
        },140);
      }

      function setSubmitting(state){
        submitting=state;
        var available=currentVariantAvailable();
        if(addButton)addButton.disabled=state||!available;
        if(stickyAdd)stickyAdd.disabled=state||!available;
      }

      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(submitting)return;

        var formData=new FormData(form);
        setSubmitting(true);

        var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        fetch(rootUrl+'cart/add.js',{
          method:'POST',
          headers:{
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:formData,
          credentials:'same-origin'
        })
          .then(function(response){
            return response.json().then(function(data){
              if(!response.ok){
                var message=(data&&data.description)||(data&&data.message)||'Could not add this product to the cart.';
                throw new Error(message);
              }
              return data;
            });
          })
          .then(function(addedProduct){
            openCartDrawer(addedProduct);
          })
          .catch(function(error){
            console.error('VASSO add to cart failed:',error);
            if(window.alert)window.alert(error.message||'Could not add this product to the cart.');
          })
          .finally(function(){
            setSubmitting(false);
          });
      });
    })();

    var sticky=root.querySelector('.vasso-pdp__sticky');
    var stickyTrigger=addButton || root.querySelector('.vasso-pdp__purchase-row') || root.querySelector('.vasso-pdp__hero');

    function getStickyTop(){
      if(!sticky)return 0;
      var candidates=[
        document.querySelector('.site-header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('[data-section-type="header"]'),
        document.querySelector('header')
      ];
      var top=0;
      candidates.forEach(function(el){
        if(!el)return;
        var style=window.getComputedStyle(el);
        if(style.position==='fixed'||style.position==='sticky'){
          var rect=el.getBoundingClientRect();
          if(rect.top<=4&&rect.bottom>top)top=rect.bottom;
        }
      });
      sticky.style.top=Math.max(0,Math.round(top))+'px';
      return top;
    }

    function updateSticky(){
      if(!sticky||!stickyTrigger)return;
      var top=getStickyTop();
      var triggerBottom=stickyTrigger.getBoundingClientRect().bottom;
      sticky.classList.toggle('is-visible',triggerBottom<=top+8);
    }

    updateSticky();
    window.addEventListener('scroll',updateSticky,{passive:true});
    window.addEventListener('resize',updateSticky);
  }
  document.querySelectorAll('[data-vasso-pdp]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasso-product-share"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async function(event) {
  var trigger = event.target.closest('[data-vasso-instagram-share]');
  if (!trigger) return;

  var root = trigger.closest('[data-vasso-product-share]');
  if (!root) return;

  var url = root.dataset.shareUrl || window.location.href;
  var title = root.dataset.shareTitle || document.title;
  var status = root.querySelector('[data-vasso-share-status]');

  function showStatus(message) {
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
    window.clearTimeout(status._vassoTimer);
    status._vassoTimer = window.setTimeout(function() {
      status.hidden = true;
    }, 3600);
  }

  async function copyUrl() {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return;
    }

    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    document.execCommand('copy');
    document.body.removeChild(field);
  }

  try {
    if (navigator.share) {
      await navigator.share({ title: title, url: url });
      return;
    }

    await copyUrl();
    showStatus(root.dataset.copiedMessage || 'Product link copied.');
  } catch (error) {
    if (error && error.name === 'AbortError') return;

    try {
      await copyUrl();
      showStatus(root.dataset.copiedMessage || 'Product link copied.');
    } catch (copyError) {
      showStatus(root.dataset.errorMessage || 'Could not open sharing.');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasso-women-routine"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoutine(section){
    var track=section.querySelector('[data-vasso-routine-track]');
    var rtl=(section.getAttribute('dir')||'').toLowerCase()==='rtl';

    function getRootUrl(){
      return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    }

    function getCurrentProductSelection(){
      var mainRoot=document.querySelector('[data-vasso-pdp][data-vasso-mode="women"]');
      if(!mainRoot)return null;

      var select=mainRoot.querySelector('[data-vasso-variant-select]');
      if(select&&select.options&&select.selectedIndex>=0){
        var option=select.options[select.selectedIndex];
        return {
          variantId:String(select.value||''),
          available:option.dataset.available!=='false'
        };
      }

      var hidden=mainRoot.querySelector('.vasso-pdp__form input[name="id"]');
      var addButton=mainRoot.querySelector('[data-vasso-add]');
      if(hidden){
        return {
          variantId:String(hidden.value||''),
          available:!addButton||!addButton.disabled
        };
      }

      return null;
    }

    function cartDrawerVisible(){
      var drawer=document.getElementById('CartDrawer');
      if(!drawer)return false;
      if(drawer.getAttribute('aria-hidden')==='false')return true;
      if(drawer.classList.contains('drawer--is-open')||drawer.classList.contains('is-open'))return true;
      var style=window.getComputedStyle(drawer);
      if(style.display==='none'||style.visibility==='hidden'||Number(style.opacity||1)===0)return false;
      var rect=drawer.getBoundingClientRect();
      return rect.width>0&&rect.height>0&&rect.right>2&&rect.left<(window.innerWidth-2);
    }

    function openCartDrawer(addedData){
      try{
        document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:addedData}}));
      }catch(error){}

      try{
        document.dispatchEvent(new CustomEvent('cart:build'));
      }catch(error){}

      window.setTimeout(function(){
        if(cartDrawerVisible())return;

        var trigger=document.querySelector('.js-drawer-open-cart[aria-controls="CartDrawer"], .js-drawer-open-cart');
        if(trigger&&typeof trigger.click==='function'){
          trigger.click();
          return;
        }

        if(window.theme&&typeof window.theme.CartDrawer==='function'){
          try{
            window.__vassoRoutineCartDrawer=window.__vassoRoutineCartDrawer||new window.theme.CartDrawer();
            if(window.__vassoRoutineCartDrawer.init&&!window.__vassoRoutineCartDrawer.__vassoInitialized){
              window.__vassoRoutineCartDrawer.init();
              window.__vassoRoutineCartDrawer.__vassoInitialized=true;
            }
            if(window.__vassoRoutineCartDrawer.open)window.__vassoRoutineCartDrawer.open();
          }catch(error){}
        }
      },140);
    }

    function readJsonResponse(response){
      return response.json().then(function(data){
        if(!response.ok){
          var message=(data&&data.description)||(data&&data.message)||'Could not update the cart.';
          throw new Error(message);
        }
        return data;
      });
    }

    section.querySelectorAll('.vasso-routine__form').forEach(function(form){
      if(form.dataset.vassoRoutineAjaxReady==='1')return;
      form.dataset.vassoRoutineAjaxReady='1';

      form.addEventListener('submit',function(event){
        event.preventDefault();

        if(form.dataset.submitting==='1')return;

        var button=form.querySelector('.vasso-routine__add');
        var relatedInput=form.querySelector('input[name="id"]');
        if(!relatedInput||!relatedInput.value||!button||button.disabled)return;

        var relatedVariantId=String(relatedInput.value);
        var currentProductId=String(section.dataset.currentProductId||'');
        var currentSelection=getCurrentProductSelection();
        var rootUrl=getRootUrl();

        form.dataset.submitting='1';
        button.disabled=true;
        button.setAttribute('aria-busy','true');

        fetch(rootUrl+'cart.js',{
          method:'GET',
          headers:{
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          credentials:'same-origin'
        })
          .then(readJsonResponse)
          .then(function(cart){
            var currentProductInCart=false;

            if(currentProductId&&cart&&Array.isArray(cart.items)){
              currentProductInCart=cart.items.some(function(item){
                return String(item.product_id)===currentProductId;
              });
            }

            var items=[];

            if(!currentProductInCart&&currentSelection&&currentSelection.variantId&&currentSelection.available){
              items.push({
                id:currentSelection.variantId,
                quantity:1
              });
            }

            items.push({
              id:relatedVariantId,
              quantity:1
            });

            return fetch(rootUrl+'cart/add.js',{
              method:'POST',
              headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'X-Requested-With':'XMLHttpRequest'
              },
              credentials:'same-origin',
              body:JSON.stringify({items:items})
            }).then(readJsonResponse);
          })
          .then(function(addedData){
            openCartDrawer(addedData);
          })
          .catch(function(error){
            console.error('VASSO routine add to cart failed:',error);
            if(window.alert)window.alert(error.message||'Could not add these products to the cart.');
          })
          .finally(function(){
            form.dataset.submitting='0';
            button.removeAttribute('aria-busy');
            button.disabled=false;
          });
      });
    });
  }

  document.querySelectorAll('[data-vasso-routine-section]').forEach(initRoutine);
})();

  } catch(e) { console.error(e); }
})();
})();
